import { render } from "./GetVerifiedModal.vue?vue&type=template&id=80ab9018&scoped=true"
import script from "./GetVerifiedModal.vue?vue&type=script&lang=js"
export * from "./GetVerifiedModal.vue?vue&type=script&lang=js"

import "./GetVerifiedModal.vue?vue&type=style&index=0&id=80ab9018&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ab9018"]])

export default __exports__